export function PageHeader({ title, description, actions, "data-testid": testId }) {
  return (
    <div
      data-testid={testId}
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 pb-6 border-b border-border"
    >
      <div>
        <h1 className="text-3xl md:text-4xl tracking-tight text-foreground">{title}</h1>
        {description && (
          <p className="mt-2 text-sm text-muted-foreground max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
